export const ASSEMBLY_LABOR_FLASH_STORAGE_KEY = "manufacturing.assembly.laborFlash";
